import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "target"]
  static values = {
    template: String,
    placeholder: { type: String, default: "%{value}" },
    onlyIfEmpty: { type: Boolean, default: true }
  }

  connect() {
    this.lastPrefilledValue = this.prefilledValue()
    this.prefill()
  }

  prefill() {
    const currentValue = this.targetTarget.value.trim()
    if (this.onlyIfEmptyValue && currentValue !== "" && currentValue !== this.lastPrefilledValue) return

    const nextValue = this.prefilledValue()
    if (!nextValue) return

    this.targetTarget.value = nextValue
    this.lastPrefilledValue = nextValue
  }

  prefilledValue() {
    const sourceText = this.sourceText()
    if (!sourceText) return null

    return this.templateValue.replace(this.placeholderValue, sourceText)
  }

  sourceText() {
    if (this.sourceTarget instanceof HTMLSelectElement) {
      if (this.sourceTarget.value === "") return null

      return this.sourceTarget.selectedOptions[0]?.text?.trim() || null
    }

    const value = this.sourceTarget.value?.trim()
    return value === "" ? null : value
  }
}
